// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-dispatch-confirmation-dialog > * {
    margin-bottom: 20px;
  }
  .save-dispatch-confirmation-dialog__title {
    font-weight: 800;
    font-size: 24px;
    line-height: 140%;
  }
  .save-dispatch-confirmation-dialog__subheading {
    font-size: 18px;
    line-height: 140%;
  }
`, "",{"version":3,"sources":["webpack://./app/pages/DispatchPage/components/DateConfirmationDialog/style.css"],"names":[],"mappings":"AACE;IACE,mBAAmB;EACrB;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB","sourcesContent":[".save-dispatch-confirmation-dialog {\n  & > * {\n    margin-bottom: 20px;\n  }\n\n  &__title {\n    font-weight: 800;\n    font-size: 24px;\n    line-height: 140%;\n  }\n\n  &__subheading {\n    font-size: 18px;\n    line-height: 140%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
